export default __webpack_public_path__ + "static/media/debt_and_liquid.31429e08.svg";